module.exports = __webpack_public_path__ + "static/media/disclaimer.c15330ad.png";